module.exports = __webpack_public_path__ + "ski-classic.1365e24c51c49b657215.svg";


//////////////////
// WEBPACK FOOTER
// /vercel/workpath0/src/assets/img/ski-classic.svg
// module id = ../../../../../src/assets/img/ski-classic.svg
// module chunks = main